import { GetActivityHistoryQuery } from '../../client/generated/graphql';
import { ActivityEventCell } from './ActivityEventCell';

type ActivityTimelineItemProps = {
    item: GetActivityHistoryQuery['eventLogs'][0];
    showDivider: boolean;
    questNameMap: Record<string, string>;
    goalNameMap: Record<string, string>;
    rewardNameMap: Record<string, string>;
    maps: {
        questMap: Record<string, any>;
        goalMap: Record<string, any>;
        categoryMap: Record<string, any>;
    };
};

export const ActivityTimelineItem = ({ item, showDivider, questNameMap, goalNameMap, rewardNameMap, maps }: ActivityTimelineItemProps) => (
    <ActivityEventCell
        item={item}
        showDivider={showDivider}
        questNameMap={questNameMap}
        goalNameMap={goalNameMap}
        rewardNameMap={rewardNameMap}
        maps={maps}
    />
);
